import {Cost} from "./cost";

export class FixCost extends Cost {
  public fixValue: number;
}
